// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"70e0b73e","455":"f8969f2b","977":"fb1dac6e"}[chunkId] + ".chunk.js";
};